import { atom } from "jotai";

export const progressAtom = atom(0);

export const currentGamePlanIndexAtom = atom(-1);
